// extracted by mini-css-extract-plugin
export default {"aboutComponent":"about_aboutComponent__gfTVn","aboutText":"about_aboutText__fH8rK"};